export enum EContactType {
  Sms = 'SMS',
  Telegram = 'TELEGRAM',
  WhatsApp = 'WHATS_APP',
  CallMe = 'CALL_ME',
}
